import _ from 'lodash';

import sockets from '../websockets';

const handleSocketAction = (action, payload, dispatch) => {
  const { socket: socketAction, type } = action;
  const { event, leave, handle, emit, namespace, ...rest } = socketAction;
  const socketInstance = _.get(sockets, [namespace, 'instance']);

  if (leave) {
    return socketInstance.removeListener(event);
  }

  if (emit) {
    if (type) {
      dispatch({ type, payload });
    }
    return socketInstance.emit(event, payload);
  }

  let handleEvent = handle;
  if (_.isString(handleEvent)) {
    handleEvent = response => dispatch({ type: handle, payload: response, ...rest });
  }
  return socketInstance.on(event, handleEvent);
};

const socketMiddleware = ({ dispatch }) => next => action => {
  if (typeof action === 'function') {
    return next(action);
  }

  if (_.has(action, 'socket.event') && _.has(action, 'socket.namespace')) {
    const { payload } = action;
    return handleSocketAction(action, payload, dispatch);
  }

  return next(action);
};

export default socketMiddleware;
